import { render } from "./OrderListForm.vue?vue&type=template&id=bd168be4"
import script from "./OrderListForm.vue?vue&type=script&lang=js"
export * from "./OrderListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__